// extracted by mini-css-extract-plugin
export default {"container":"Signature_container__JYqOe","image":"Signature_image__pcCOs","infos":"Signature_infos__44kLS"};